export default "__VITE_ASSET__BfY7mT5Q__"